let initialState = {
	ticketTatSimpleViewData: null,
	ticketTatSimpleViewStatus: false,
};
const TicketTATSimpleView = (state = initialState, action) => {
	switch (action.type) {
		case "SET_TICKET_TAT_SIMPLE_VIEW_FETCH":
			return {
				...state,
				ticketTatSimpleViewData: action.payload,
			};

		case "SET_TICKET_TAT_SIMPLE_VIEW_STATUS":
			return {
				...state,
				ticketTatSimpleViewStatus: action.payload,
			};

		default:
			return state;
	}
};

export default TicketTATSimpleView;
